import API from "../api";
import i18n from "../i18n";
import { formatLocalDateTime, todayIso } from "../utils/date";

export const getAuditLogs = async (params) => {
  const response = await API.get("/admin/audit-logs", { params });
  return response.data;
};

export const getAuditLogTables = async () => {
  const response = await API.get("/admin/audit-logs/tables");
  return response.data;
};

export const getAuditLogOperations = async () => {
  const response = await API.get("/admin/audit-logs/operations");
  return response.data;
};

export const exportAuditLogsToCSV = (data) => {
  const na = i18n.t('common.na', { defaultValue: 'N/A' });
  const headers = [
    i18n.t('pages.auditLogs.colTimestamp'),
    i18n.t('pages.auditLogs.filterUser'),
    i18n.t('pages.auditLogs.colTable'),
    i18n.t('pages.auditLogs.colOperation'),
    i18n.t('pages.auditLogs.colRecordId'),
    i18n.t('pages.auditLogs.oldData'),
    i18n.t('pages.auditLogs.newData'),
  ];
  const csvContent = [
    headers.join(","),
    ...data.map((row) =>
      [
        formatLocalDateTime(row.created),
        row.userName || na,
        row.tableName
          ? i18n.t(`pages.auditLogs.tables.${row.tableName}`, {
              defaultValue: String(row.tableName).replace(/_/g, ' '),
            })
          : na,
        row.operation
          ? i18n.t(`pages.auditLogs.ops.${row.operation}`, {
              defaultValue: String(row.operation).replace(/_/g, ' '),
            })
          : na,
        row.recordId || na,
        `"${(row.oldData || "").replace(/"/g, '""')}"`,
        `"${(row.newData || "").replace(/"/g, '""')}"`,
      ].join(","),
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `audit_logs_${todayIso()}.csv`;
  link.click();
};
